import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import Input from '../../../common/input';
import CancelButtonLink from '../../../common/buttons/cancelButtonLink';
import AdminSaveButton from '../../shared/Buttons/AdminSaveButton';
import AdminDeleteButton from '../../shared/Buttons/AdminDeleteButton';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import Tooltip from '../../../common/tooltip';

const Form = ({
  handleSubmit,
  pristine,
  submitting,
  valid,
  onDelete,
  initialValues,
}) => (
  <form onSubmit={handleSubmit}>
    <fieldset disabled={submitting}>
      <div className="layout">
        <div className="layout__item">
          <span className="c-label-new">{t('subscription:plan_name_label')}</span>
          <Input
            className="c-input"
            name="name"
            type="text"
            placeholder={t('subscription:plan_name_label')}
          />
        </div>
      </div>
      <div className="layout u-mt">
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="extraFeatures"
            id="extraFeatures"
            label={t('subscription:form.extra_features')}
            wrapperClass="u-inline-block"
          />
          <Tooltip>
            {t('subscription:form.extra_features_tooltip')}
          </Tooltip>
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="customApp"
            id="customApp"
            label={t('subscription:form.custom_app')}
            wrapperClass="u-inline-block"
          />
          <Tooltip>{t('subscription:form.custom_app_tooltip')}</Tooltip>
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="campaignsEnabled"
            id="campaignsEnabled"
            label={t('subscription:form.engage')}
            wrapperClass="u-inline-block"
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="commissionReportingEnabled"
            id="commissionReportingEnabled"
            label={t('subscription:form.commission_reports')}
            wrapperClass="u-inline-block"
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="productReportingEnabled"
            id="productReportingEnabled"
            label={t('subscription:form.product_reports')}
            wrapperClass="u-inline-block"
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="customReportingEnabled"
            id="customReportingEnabled"
            label={t('subscription:form.custom_reports_enterprise')}
            wrapperClass="u-inline-block"
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="chatEnabled"
            id="chatEnabled"
            label={t('subscription:form.chat')}
            wrapperClass="u-inline-block"
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="conversionTracking"
            id="conversionTracking"
            label="Conversion Tracking"
            wrapperClass="u-inline-block"
          />
        </div>
      </div>
      <div display-if={initialValues.id} className="c-heading c-heading--small c-heading--dark u-mt">
        {t('subscription:form.active_subscriptions')}: <strong>{initialValues.activeSubscriptionsCount}</strong>
      </div>
      <div className="c-separator u-mt" />
      <div className="u-mt-">
        <small display-if={initialValues.id && initialValues.activeSubscriptionsCount > 0}>
          {t('subscription:form.cannot_delete_plan')}
        </small>
      </div>
      <div className="u-text-right">
        <AdminDeleteButton
          className="c-btn c-btn--red u-width-120 u-mr- u-float-left"
          onClick={onDelete}
          display-if={onDelete}
          disabled={initialValues.id && initialValues.activeSubscriptionsCount > 0}
          title={t('subscription:form.cannot_delete_tooltip')}
        />
        <CancelButtonLink link="/admin/subscription/plans" content={t('buttons.cancel')} />
        <AdminSaveButton disabled={pristine || !valid} content={t('subscription:form.save_button')} />
      </div>
    </fieldset>
  </form>
);

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  initialValues: PropTypes.object.isRequired,
};
Form.defaultProps = {
  onDelete: null,
};

export default Form;
